import { LessonLink } from "@jelly/lesson";
import { findChapterForLinkByCourseLesson } from "../../../../services/Utils";
import course05 from "../../../course/course-05/course";
import lesson0516 from "../../../lesson/course-05/lesson-16/lesson";
import lesson0517 from "../../../lesson/course-05/lesson-17/lesson";
import lesson0522 from "../../../lesson/course-05/lesson-22/lesson";

const lessonLinks: LessonLink[] = [
  {
    id: "1393ae2f-94cc-4e46-a3b6-cc9cd4a084cb",
    course: {
      id: course05.id,
      slug: course05.slug as string,
      name: course05.name,
      publicId: course05.publicId,
    },
    chapter: findChapterForLinkByCourseLesson(course05, lesson0516),
    lesson: lesson0516,
  },
  {
    id: "f6b06004-5d52-494b-9b6f-b32d93dcdd8f",
    course: {
      id: course05.id,
      slug: course05.slug as string,
      name: course05.name,
      publicId: course05.publicId,
    },
    chapter: findChapterForLinkByCourseLesson(course05, lesson0517),
    lesson: lesson0517,
  },
  {
    id: "d094f20a-bd59-461f-8769-87a3b6224e41",
    course: {
      id: course05.id,
      slug: course05.slug as string,
      name: course05.name,
      publicId: course05.publicId,
    },
    chapter: findChapterForLinkByCourseLesson(course05, lesson0522),
    lesson: lesson0522,
  },
];

export default lessonLinks;
